import React, { useEffect } from 'react';
import { Cureus } from '../../Cureus';

const Ad = ({ props, size }) => {

  useEffect(() => {
    // new Cureus.Ads(props);
  }, [])

  return (
    <div></div>
  )
}

export default Ad;